module.exports = __webpack_public_path__ + "static/media/logo_portal_webBase.f615144b.png";